import React from "react";
import { Navigate, useLocation, useParams } from "react-router-dom";

const withLocation = (target, location) => `${target}${location.search}${location.hash}`;

export function BrandStudioLegacyRedirect({ to }) {
  const location = useLocation();
  return <Navigate to={withLocation(to, location)} replace />;
}

export function BrandStudioLegacyWorkspaceRedirect() {
  const location = useLocation();
  const { workspaceSlug } = useParams();
  return <Navigate to={withLocation(`/brand-studio/${workspaceSlug}`, location)} replace />;
}
